(function () {
  if (window.__mtInit) return;
  window.__mtInit = true;

  var sinMovimiento = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var observador = null;

  function vigilar(el) {
    if (sinMovimiento || !('IntersectionObserver' in window)) { el.classList.add('mt-visible'); return; }
    if (!observador) {
      observador = new IntersectionObserver(function (entradas) {
        entradas.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('mt-visible'); observador.unobserve(e.target); }
        });
      }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
    }
    observador.observe(el);
  }

  function initReveals(raiz) {
    raiz.querySelectorAll('.mt-reveal, .mt-pasos-grid, .mt-comp-tabla').forEach(function (el) {
      if (el.dataset.mtReveal) return;
      el.dataset.mtReveal = '1';
      vigilar(el);
    });
  }

  function initHeroes(raiz) {
    raiz.querySelectorAll('.mt-hero').forEach(function (h) {
      if (h.dataset.mtHero) return;
      h.dataset.mtHero = '1';
      setTimeout(function () { h.classList.add('mt-listo'); }, 60);
    });
  }

  function initComparadores(raiz) {
    raiz.querySelectorAll('.mt-ad-comp').forEach(function (c) {
      if (c.dataset.mtComp) return;
      c.dataset.mtComp = '1';
      var rango = c.querySelector('.mt-ad-rango');
      if (!rango) return;
      var aplicar = function () { c.style.setProperty('--mt-pos', rango.value + '%'); };
      rango.addEventListener('input', aplicar);
      aplicar();
    });
  }

  function initFaq(raiz) {
    raiz.querySelectorAll('.mt-faq-item').forEach(function (item) {
      if (item.dataset.mtFaq) return;
      item.dataset.mtFaq = '1';
      var btn = item.querySelector('.mt-faq-btn');
      if (!btn) return;
      var panel = item.querySelector('.mt-faq-panel');
      btn.addEventListener('click', function () {
        var abierto = !item.classList.contains('mt-abierto');
        if (abierto) {
          item.classList.add('mt-abierto');
          panel.style.maxHeight = '0px';
          panel.offsetHeight;
          panel.style.maxHeight = panel.scrollHeight + 'px';
        } else {
          panel.style.maxHeight = panel.scrollHeight + 'px';
          panel.offsetHeight;
          item.classList.remove('mt-abierto');
          panel.style.maxHeight = '0px';
        }
        btn.setAttribute('aria-expanded', abierto ? 'true' : 'false');
      });
      panel.addEventListener('transitionend', function () {
        if (item.classList.contains('mt-abierto')) panel.style.maxHeight = 'none';
      });
    });
  }

  function initGalerias(raiz) {
    raiz.querySelectorAll('.mt-pp-galeria').forEach(function (g) {
      if (g.dataset.mtGal) return;
      g.dataset.mtGal = '1';
      var principal = g.querySelector('.mt-pp-principal img');
      g.querySelectorAll('.mt-pp-mini').forEach(function (m) {
        m.addEventListener('click', function () {
          if (!principal) return;
          principal.src = m.dataset.src;
          principal.alt = m.dataset.alt || '';
          g.querySelectorAll('.mt-pp-mini').forEach(function (x) { x.classList.remove('mt-activa'); });
          m.classList.add('mt-activa');
        });
      });
    });
  }

  function initVariantes(raiz) {
    raiz.querySelectorAll('.mt-pp-form[data-variantes]').forEach(function (f) {
      if (f.dataset.mtVar) return;
      f.dataset.mtVar = '1';
      var datos = document.getElementById(f.dataset.variantes);
      if (!datos) return;
      var variantes = JSON.parse(datos.textContent);
      var selects = f.querySelectorAll('.mt-pp-opcion select');
      var idInput = f.querySelector('input[name="id"]');
      var boton = f.querySelector('button[type="submit"]');
      var precio = document.querySelector('[data-mt-precio="' + f.dataset.seccion + '"]');
      var formato = function (cents) { return (cents / 100).toFixed(2).replace('.', ',') + ' ' + (f.dataset.moneda || ''); };
      selects.forEach(function (s) {
        s.addEventListener('change', function () {
          var elegidas = Array.prototype.map.call(selects, function (x) { return x.value; });
          var v = variantes.find(function (x) { return x.options.every(function (o, i) { return o === elegidas[i]; }); });
          if (!v) { boton.disabled = true; boton.textContent = f.dataset.textoNo; return; }
          idInput.value = v.id;
          boton.disabled = !v.available;
          boton.textContent = v.available ? f.dataset.textoSi : f.dataset.textoAgotado;
          if (precio) {
            precio.innerHTML = '<span>' + formato(v.price) + '</span>' + (v.compare_at_price > v.price ? '<s>' + formato(v.compare_at_price) + '</s>' : '');
          }
        });
      });
    });
  }

  function initTodo(e) {
    var raiz = (e && e.target && e.target.querySelectorAll) ? e.target : document;
    initHeroes(raiz);
    initReveals(raiz);
    initComparadores(raiz);
    initFaq(raiz);
    initGalerias(raiz);
    initVariantes(raiz);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initTodo(); });
  else initTodo();
  document.addEventListener('shopify:section:load', initTodo);
})();
